import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Modal } from "react-bootstrap";

type ModalProps = {
    show: boolean;
    onAgree: () => void;
};

const ModalAuditConfirm = (props: ModalProps) => {
    return (
        <Modal
            show={props.show}
            onHide={props.onAgree}
            centered
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Confirmar</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={{ fontWeight: "bold" }}>
                    Estás por completar la auditoría.
                </p>
                <p>
                    Por favor, verifica tus respuestas y agrega un comentario si
                    lo deseas.
                </p>
                <p>
                    Después de verificar tus datos y que todo esté correcto, por
                    favor, da click en "Completar", de lo contrario, haz click
                    en "Regresar" y corrige tus respuestas.
                </p>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <Button variant="primary" onClick={props.onAgree}>
                    <FontAwesomeIcon
                        icon={faCheck}
                        style={{ paddingRight: "3px" }}
                    />
                    <span className="ms-2">De acuerdo</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalAuditConfirm;
